import { useMemo } from 'react';
import { IAssignment } from '@/components/interfaces';
import useGradesTableStore from '@/components/staffer/AssignmentsBasedGradesTable/store/useGradesTableStore';

export function getAssignableItems(assignment: IAssignment) {
  return Object
    .values(assignment.assignment_models_hash)
    .flat()
    .filter(assignmentModel => assignmentModel.assignment_type !== 'Section')
    .sort((a, b) => {
      if (a.section_position < b.section_position) return -1;
      if (a.section_position === b.section_position) {
        if (['ReadingGame', 'Section', 'Notebook'].includes(a.assignment_type)) return -1;

        return 1;
      }

      return 1;
    });
}

export function useAssignedItems(assignmentArg?: IAssignment) {
  const storeAssignment = useGradesTableStore(state => state.assignment);
  const assignment = assignmentArg || storeAssignment;

  return useMemo(() => getAssignableItems(assignment), [assignment.id]);
}
